var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownNormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 18,
    viewBox: "0 0 30 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6019 16.9334C14.3829 17.7144 15.6492 17.7144 16.4303 16.9334L29.1583 4.20562C29.9394 3.42458 29.9394 2.15825 29.1584 1.37719C28.3773 0.596132 27.111 0.596118 26.33 1.37716L15.0161 12.6907L3.70254 1.3769C2.9215 0.595845 1.65517 0.59583 0.874109 1.37687C0.093051 2.15791 0.0930371 3.42424 0.874077 4.2053L13.6019 16.9334ZM13.0161 13L13.0161 15.5191L17.0161 15.5192L17.0161 13L13.0161 13Z",
    fill: "#7C838A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownNormal);
export default __webpack_public_path__ + "static/media/arrow-down-normal.94e711e638d54f09067af6922b6b015c.svg";
export { ForwardRef as ReactComponent };